<div class="relative flex items-center" [ngClass]="{'opacity-50 pointer-events-none': disabled}">
  <select [disabled]="disabled" [ngModel]="selectedOption" (change)="onChange($event)">
    <option value="" [selected]="!selectedOption" hidden>{{ input.placeholder | translate }}</option>
    <option *ngFor="let option of input.options" [value]="option.value">{{ option.label | translate }}</option>
  </select>
  <ion-icon
    src="../../../assets/svg/arrowDown.svg"
    class="absolute right-5 text-[17px]"
    color="primary"
  ></ion-icon>
</div>
